import { useGetValorantAgents } from './useGetValorantAgents';

/**
 * Hook to get a single Valorant agent by UUID.
 * Returns undefined if agent is not found.
 */
export function useGetValorantAgentById(agentId: string | undefined) {
  const { data: agent } = useGetValorantAgents({
    options: {
      select: data => {
        if (!agentId) return undefined;
        return data.agents.find(agent => agent.uuid === agentId);
      },
    },
  });

  return agent;
}
